import Container from '@/components/atoms/Container'
import Spinner from '@/components/atoms/Spinner'
import profileAwariService from '@/services/profileAwariService'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

export function Credits() {
	const navigate = useNavigate()

	const { data: dataProfileAwari, isLoading } =
		profileAwariService.getProfileAwari()

	return (
		<div className='w-full pt-6 pb-14'>
			<Container>
				<div className='flex flex-col gap-8'>
					<div className='flex flex-col gap-3'>
						<h1 className='text-2xl text-white font-medium'>Meu Saldo</h1>
						<h3 className='text-base text-white/70'>
							Acompanhe seu saldo de créditos que servem para marcar mentorias
							na plataforma
						</h3>
					</div>

					{(() => {
						if (isLoading) {
							return (
								<div className='flex justify-center'>
									<Spinner
										className={
											'inline w-10 h-10 text-gray-200 animate-spin fill-brand-primary'
										}
									/>
								</div>
							)
						}

						return (
							<div className='flex items-center gap-4'>
								<div className='flex items-center gap-3'>
									<img
										src='/imgs/admin/awari-coin.png'
										alt='Emoji'
										className='w-8 h-8 hidden md:flex'
									/>
									<span
										className={twMerge(
											'text-2xl text-white font-semibold',
											classNames({ 'text-xl': !dataProfileAwari?.balance })
										)}
									>
										{dataProfileAwari?.balance ||
											'Você não possui nenhum crédito'}
									</span>
								</div>
								<button
									onClick={() => navigate('/creditos')}
									className={twMerge(
										'flex gap-2 underline items-center text-base font-medium text-start text-white/70',
										classNames({ 'hidden text-sm': !dataProfileAwari?.balance })
									)}
								>
									Ver histórico de mentorias
								</button>
							</div>
						)
					})()}
				</div>
			</Container>
		</div>
	)
}
